module.exports = __webpack_public_path__ + "img/customer-service-en.718991b5.svg";